import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { LayoutStore } from '../../../../store/layout.store';
import { ENTITY_ICONS } from '../../../../config/entity-icons.config';
import { AppTileComponent } from './app-tile/app-tile.component';

export interface AppTile {
  icon: string;
  color: string;
  title: string;
  subtitle: string;
  link?: string;
  action?: string;
}

const TOOL_TILES: AppTile[] = [
  {
    icon: 'solar:settings-line-duotone',
    color: 'settings',
    title: 'menu.settings',
    subtitle: 'Settings',
    link: '/app/settings',
  },
  {
    icon: 'solar:gift-line-duotone',
    color: 'upcoming',
    title: 'Upcoming Features',
    subtitle: 'Coming soon',
    link: '/app/upcoming-features',
  },
];

const MAIN_TILES: AppTile[] = [
  {
    icon: 'solar:clipboard-check-line-duotone',
    color: 'accounting',
    title: 'menu.accountingReview',
    subtitle: 'Review entries',
    link: '/app/accounting/review'
  },
  {
    icon: ENTITY_ICONS.inventory,
    color: 'inventory',
    title: 'menu.inventory',
    subtitle: 'Stock management',
    link: '/app/inventory'
  },
  {
    icon: ENTITY_ICONS.reports,
    color: 'accounting',
    title: 'menu.reportsDashboard',
    subtitle: 'Financial reports',
    link: '/app/reports/dashboard'
  },
  {
    icon: ENTITY_ICONS.accounting,
    color: 'accounting',
    title: 'menu.transactions',
    subtitle: 'Financial transactions',
    link: '/app/transactions'
  },
  {
    icon: ENTITY_ICONS.team,
    color: 'team',
    title: 'menu.team',
    subtitle: 'Team management',
    link: '/app/team/dashboard'
  },
  {
    icon: ENTITY_ICONS.drafts,
    color: 'drafts',
    title: 'menu.drafts',
    subtitle: 'Draft documents',
    link: '/app/drafts'
  },
  {
    icon: ENTITY_ICONS.buildings,
    color: 'buildings',
    title: 'menu.buildings',
    subtitle: 'Manage buildings',
    link: '/app/buildings'
  },
  {
    icon: ENTITY_ICONS.equipment,
    color: 'equipment',
    title: 'menu.equipment',
    subtitle: 'Manage equipment',
    link: '/app/equipment/tiles'
  },
  {
    icon: ENTITY_ICONS.livestock,
    color: 'livestock',
    title: 'menu.livestock',
    subtitle: 'Livestock dashboard',
    link: '/app/livestock/dashboard'
  },
  {
    icon: ENTITY_ICONS.crops,
    color: 'crops',
    title: 'menu.crops',
    subtitle: 'Crops dashboard',
    link: '/app/crops/dashboard'
  },
  {
    icon: ENTITY_ICONS.fields,
    color: 'fields',
    title: 'menu.fields',
    subtitle: 'View and manage',
    link: '/app/fields'
  },
  {
    icon: ENTITY_ICONS.tasks,
    color: 'tasks',
    title: 'menu.tasks',
    subtitle: 'Task management',
    link: '/app/tasks'
  },
  {
    icon: ENTITY_ICONS.aiAssistant,
    color: 'ai-assistant',
    title: 'menu.vocalAssistant',
    subtitle: 'AI Assistant',
    action: 'openVocalAssistant'
  },
  {
    icon: ENTITY_ICONS.dashboard,
    color: 'dashboard',
    title: 'menu.dashboard',
    subtitle: 'Main dashboard',
    link: '/app/dashboard'
  },
];

@Component({
  selector: 'app-apps-grid',
  imports: [
    AppTileComponent,
  ],
  templateUrl: './apps-grid.component.html',
  styleUrls: ['./apps-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppsGridComponent {
  private layoutStore = inject(LayoutStore);

  public toolTiles = TOOL_TILES;
  public mainTiles = MAIN_TILES;
  public clickOnTile = output<void>();

  public onTileClick(): void {
    this.clickOnTile.emit();
  }

  public onTileAction(tile: AppTile): void {
    if (tile.action === 'openVocalAssistant') {
      this.layoutStore.openFullPanelModal('vocal-assistant');
      this.clickOnTile.emit();
    }
  }
}
